// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_IDENTITY_SERVER_URL,
  ENDPOINTS: {
    LOGIN: '/api/v1/account/login',
    VALIDATE_PIN: '/api/v1/account/validate-pin',
    REFRESH_TOKEN: '/api/v1/account/refresh-token',
    // Subscription endpoints
    SUBSCRIPTIONS: '/api/v1/subscriptions',
    SUBSCRIPTION_BY_ID: (id: string) => `/api/v1/subscriptions/${id}`,
    SUBSCRIPTION_MODULES: (id: string) => `/api/v1/subscriptions/${id}/modules`,
          // Tenant endpoints
          TENANTS: '/api/v1/tenants',
          TENANT_BY_ID: (id: string) => `/api/v1/tenants/${id}`,
          // Role endpoints
          ROLES: '/api/v1/roles',
          ROLE_BY_ID: (id: string) => `/api/v1/roles/${id}`,
          // Permission endpoints
          PERMISSIONS: '/api/v1/permissions',
          PERMISSION_BY_ID: (id: string) => `/api/v1/permissions/${id}`,
          PERMISSION_ROLES: (id: string) => `/api/v1/permissions/${id}/roles`,
          // User endpoints
          USERS: '/api/v1/users',
          USER_BY_ID: (id: string) => `/api/v1/users/${id}`,
          // Dashboard endpoints
          DASHBOARD_STATISTICS: '/api/v1/dashboard/statistics',
  },
};

// Debug logging
console.log('Environment variable:', import.meta.env.VITE_IDENTITY_SERVER_URL);
console.log('API Base URL:', API_CONFIG.BASE_URL);
console.log('Full Login URL:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.LOGIN); 